import React from 'react';

//Estilos
import './Map.css';

function Map({ functions, states }) {
    const { mapDiv } = states;

    return <div className="map-container" ref={mapDiv}></div>;
}

export default Map;
